import { subjectDetailsActionTypes } from './Constants';

export function getSubjectDetails(data) {
	return {
		type: subjectDetailsActionTypes.GET_SUBJECT_DETAILS,
		payload: { data },
	};
}

export function getSubjectDetailsSuccess(data) {
	return {
		type: subjectDetailsActionTypes.GET_SUBJECT_DETAILS_SUCCESS,
		payload: { data },
	};
}

export function getSubjectDetailsError() {
	return {
		type: subjectDetailsActionTypes.GET_SUBJECT_DETAILS_ERROR,
	};
}

export function getSubjectTopics(data) {
	return {
		type: subjectDetailsActionTypes.GET_SUBJECT_TOPICS,
		payload: { data },
	};
}

export function getSubjectTopicsSuccess(data) {
	return {
		type: subjectDetailsActionTypes.GET_SUBJECT_TOPICS_SUCCESS,
		payload: { data },
	};
}

export function getSubjectTopicsError() {
	return {
		type: subjectDetailsActionTypes.GET_SUBJECT_TOPICS_ERROR,
	};
}

export function getSubjectExams(data) {
	return {
		type: subjectDetailsActionTypes.GET_SUBJECT_EXAMS,
		payload: { data },
	};
}

export function getSubjectExamsSuccess(data) {
	return {
		type: subjectDetailsActionTypes.GET_SUBJECT_EXAMS_SUCCESS,
		payload: { data },
	};
}

export function getSubjectExamsError() {
	return {
		type: subjectDetailsActionTypes.GET_SUBJECT_EXAMS_ERROR,
	};
}

export function setLoadingLists() {
	return {
		type: subjectDetailsActionTypes.SET_SUBJECT_DETAILS_LISTS_LOADING,
	};
}

export function changeFilters(data) {
	return {
		type: subjectDetailsActionTypes.CHANGE_SUBJECT_TOPICS_FILTERS,
		payload: { data },
	};
}

export function cleanSubjectDetailsState() {
	return {
		type: subjectDetailsActionTypes.CLEAN_SUBJECT_DETAILS_STATE,
	};
}
